"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRESCRIPTIONS = void 0;
const client_1 = require("@apollo/client");
exports.PRESCRIPTIONS = (0, client_1.gql) `
  query Prescriptions(
    $typeId: Int!
    $query: String
    $cursor: Int
    $limit: Int
  ) {
    restricted {
      prescriptions(
        typeId: $typeId
        query: $query
        cursor: $cursor
        limit: $limit
      ) {
        total
        result {
          ... on Drug {
            id
            name
            __typename
          }
          ... on Dose {
            id
            name
            __typename
          }
          ... on Duration {
            id
            name
            __typename
          }
          ... on Frequency {
            id
            name
            __typename
          }
          ... on Route {
            id
            name
            __typename
          }
        }
      }
    }
  }
`;
